import { FC } from 'react';

import { CtaProvider } from '../CtaProvider/CtaProvider';
import { CtaData } from './model';

type Props = {
    cta: CtaData;
    dataTest?: string;
};

export const ImageLink: FC<Props> = ({ cta, dataTest }) => {
    return (
        <CtaProvider cta={cta}>
            {({ href, target, rel, image, onClick }) =>
                href ? (
                    <a href={href} target={target} rel={rel} onClick={onClick} data-test={dataTest}>
                        <img src={image.src} alt={image.alt} loading="lazy" />
                    </a>
                ) : (
                    <button onClick={onClick} data-test={dataTest}>
                        <img src={image.src} alt={image.alt} loading="lazy" />
                    </button>
                )
            }
        </CtaProvider>
    );
};
